import React, { Component } from "react";
import { connect } from "react-redux";
import { editManagedApp } from "../redux/actions/appActions";
import { EditManagedAppDialog } from "../dialogs/EditManagedAppDialog";

export class EditManagedApp extends Component {
  state = {
    title: "",
    description: "",
    vrTypes: [],
    categories: [],
    saveAvaliable: true,
    organizationKey: "",
    globalAccess: false,
    sortPriority: 0
  };

  componentDidMount() {
    const {
      app: {
        title,
        description,
        vrTypes,
        categories,
        sortPriority = 0,
        organizationRef,
        globalAccess
      }
    } = this.props;
    const organizationKey = organizationRef.id;
    this.setState({
      title,
      description,
      vrTypes,
      categories,
      sortPriority,
      organizationKey,
      globalAccess
    });
  }

  onTitleChange = title => this.setState({ title }, this.checkSaveAvaliable);

  onDescriptionChange = description => this.setState({ description });

  onIconFileChange = icon => this.setState({ icon });

  onOrganizationChange = organizationKey =>
    this.setState({ organizationKey }, this.checkSaveAvaliable);

  onGlobalAccessChange = globalAccess => this.setState({ globalAccess });

  onSortPriorityChange = input => {
    if (input.length === 0) input = 0;
    let sortPriority = parseInt(input);
    if (isNaN(sortPriority)) sortPriority = this.state.sortPriority;
    if (input === "-") sortPriority = "-";
    this.setState({ sortPriority });
  }

  saveChanges = () => {
    const {
      title,
      description,
      vrTypes,
      categories,
      icon,
      organizationKey,
      globalAccess,
      sortPriority
    } = this.state;
    const { selectedKey, onClose, editManagedApp, app } = this.props;

    editManagedApp({
      key: selectedKey,
      title,
      packageName: app.packageName,
      description,
      vrTypes,
      categories,
      icon,
      oldIconUrl: app.iconUrl,
      organizationKey,
      globalAccess,
      sortPriority: isNaN(parseInt(sortPriority)) ? 0 : sortPriority
    });
    onClose();
  };

  checkSaveAvaliable = () => {
    const { title, organizationKey } = this.state;
    let saveAvaliable = true;
    if (title === "" || organizationKey === "") saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onCategoriesChange = categories => this.setState({ categories });

  onVrTypesChange = vrTypes => this.setState({ vrTypes });

  render() {
    const { onClose, app, dialogTitle } = this.props;
    const {
      title,
      icon,
      vrTypes,
      categories,
      sortPriority,
      description,
      saveAvaliable,
      organizationKey,
      globalAccess
    } = this.state;
    return (
      <EditManagedAppDialog
        dialogTitle={dialogTitle}
        app={app}
        onClose={onClose}
        onSave={this.saveChanges}
        saveAvaliable={saveAvaliable}
        title={title}
        onTitleChange={this.onTitleChange}
        vrTypes={vrTypes}
        onVrTypesChange={this.onVrTypesChange}
        categories={categories}
        onCategoriesChange={this.onCategoriesChange}
        sortPriority={sortPriority}
        onSortPriorityChange={this.onSortPriorityChange}
        description={description}
        onDescriptionChange={this.onDescriptionChange}
        iconName={icon && icon.name}
        onIconFileChange={this.onIconFileChange}
        obbUrls={app.obbUrls}
        organizationKey={organizationKey}
        onOrganizationChange={this.onOrganizationChange}
        globalAccess={globalAccess}
        onGlobalAccessChange={this.onGlobalAccessChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  apps: state.data.apps
});

const mapDispatchToProps = {
  editManagedApp
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditManagedApp);
